const PaymentStatusToggle = (props: any) => {
  const { active, setActive, reportType } = props;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #18C5A7",
        width: "fit-content",
      }}
    >
      <div
        onClick={() => setActive(0)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: active === 0 ? "#18C5A7" : "#fff",
          color: active === 0 ? "#ffffff" : "#757575",
          textTransform: "none",
          padding: "5px 10px",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "500",
          border: "none",
        }}
      >
        Paid
      </div>
      <div
        onClick={() => setActive(1)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: active === 1 ? "#18C5A7" : "#fff",
          color: active === 1 ? "#ffffff" : "#757575",
          textTransform: "none",
          padding: "5px 10px",
          cursor: "pointer",
          borderRight: "1px solid #18C5A7",
          borderLeft: "1px solid #18C5A7",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        Overdue
      </div>
      <div
        onClick={() => setActive(2)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: active === 2 ? "#18C5A7" : "#fff",
          color: active === 2 ? "#ffffff" : "#757575",
          textTransform: "none",
          padding: "5px 10px",
          cursor: "pointer",
          borderRight: reportType === "MONTH_LEVEL" ? "1px solid #18C5A7" : "none",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        Pending
      </div>
      {reportType === "MONTH_LEVEL" && (
        <div
          onClick={() => setActive(3)}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: active === 3 ? "#18C5A7" : "#fff",
            color: active === 3 ? "#ffffff" : "#757575",
            textTransform: "none",
            padding: "5px 10px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            border: "none",
          }}
        >
          Upcoming
        </div>
      )}
    </div>
  );
};

export default PaymentStatusToggle;
